export const CREATE_GRADE  = 'CREATE_GRADE';
export const GET_GRADE  = 'GET_GRADE';
export const GRADE_REQUEST  = 'GRADE_REQUEST';
export const DELETE_GRADE  = 'DELETE_GRADE';
export const UPDATE_GRADE  = 'UPDATE_GRADE';
export const GRADE_REQUEST_FAILURE  = 'GRADE_REQUEST_FAILURE';